import { render } from "./CreateBudget.vue?vue&type=template&id=01e0571a"
import script from "./CreateBudget.vue?vue&type=script&lang=js"
export * from "./CreateBudget.vue?vue&type=script&lang=js"

import "./CreateBudget.vue?vue&type=style&index=0&id=01e0571a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__